var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c("el-date-picker", {
            ref: _vm.reference,
            attrs: {
              valueFormat: "timestamp",
              type: "date",
              format: "dd/MM/yyyy",
              pickerOptions: _vm.datePickerOptions,
              placeholder: _vm.$t.__("common.labels.date")
            },
            on: { change: _vm.update },
            model: {
              value: _vm.currentValue,
              callback: function($$v) {
                _vm.currentValue = $$v
              },
              expression: "currentValue"
            }
          })
        : _c("p", [_vm._v("\n        " + _vm._s(_vm.date) + "\n    ")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }